import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { entityRouteRef } from '@backstage/plugin-catalog-react';
import { PageErrorBoundary } from '@vivicta/ui';

/**
 * Replaces `page:catalog/entity` from `@backstage/plugin-catalog` with a
 * Tailwind/shadcn page (ADR-0012), same pattern as `modules/catalog` (index
 * page) and `modules/apiDocs`. `noHeader` suppresses the stock `PluginHeader`
 * since the page renders its own `@vivicta/ui` `Header`.
 *
 * `routeRef` must be the real singleton `entityRouteRef` object (converted
 * for the new frontend system), not a string alias — confirmed by reading the
 * stock implementation in
 * `node_modules/@backstage/plugin-catalog/dist/alpha/pages.esm.js`, which
 * uses exactly `convertLegacyRouteRef(entityRouteRef)` for this same page.
 * There is no named route alias ('catalog.catalogEntity' does not exist) to
 * use instead.
 *
 * The stock `entity-content:*` sub-extensions (catalog/overview,
 * api-docs/definition, api-docs/apis, techdocs) are disabled in
 * `app-config.yaml` — this page's `loader` ignores the `contents` input
 * entirely, so they would otherwise be instantiated with nothing to attach
 * to.
 */
export const catalogEntityModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    PageBlueprint.make({
      name: 'entity',
      params: {
        path: '/catalog/:namespace/:kind/:name',
        noHeader: true,
        routeRef: convertLegacyRouteRef(entityRouteRef),
        loader: () =>
          import('./CatalogEntityPage').then(m => (
            <PageErrorBoundary title="Catalog entity">
              <m.CatalogEntityPage />
            </PageErrorBoundary>
          )),
      },
    }),
  ],
});
